export enum DietsEnum {
	Vegan = 'dca1d281-6762-483d-bc9c-95d51ec46892',
	Vegetarian = 'ee0535c2-1c3b-4e8f-b7ce-ad77006f1bf8',
	Keto = '6d1717e8-834f-4e5f-bcc3-cbd4cdd3c27b',
	Paleo = '08bb2038-ede4-4907-9968-0b0ea04444dd',
	LowCarb = '01dde9ce-5363-4cd5-99f4-968d20553657',
	Dunkan = '21b154f4-ad1c-4c45-867f-04395109ce0e',
	DairyFree = '9690a0c4-390e-4ae7-aaea-370eeab719a6',
	GlutenFree = '4cf49c12-f98f-434c-97bf-b523f52bd2ac',
	Atkins = '61b97dc0-796e-47d1-9200-d10afaf1db80',
	HCG = '179fd30c-a31d-4ff1-9af0-f17ba7afe65e',
	Fad = 'c1c6f1f7-a63b-43dd-9382-bd61d560c32b',
	IntermittentFasting = 'bcd23610-d7f0-417a-af0a-0be5db1cda49',
	Pescatarian = '5b5cc96d-09b8-4905-b555-42a26cfc3238',
}
